import {defineMessages} from "react-intl";

export default defineMessages({
    rowsPerPage: { id: "pagination.rowsPerPage", defaultMessage: "Rows per page", description: 'Pagination: Rows per page' },
    total: { id: "pagination.total", defaultMessage: "total", description: 'Pagination: total' },
})
